<template>

<app-panel v-on:close="$emit('close')" :loading="is.loading" class="preview">

    <template v-if="!is.loading">
		
        <component v-bind:is="componentName" :item="item" :references="references" />

        <app-panel-content :space="true" v-if="hasRoute">

            <app-button text="Go to full details" v-on:click="onManageClick" />

        </app-panel-content>

    </template>
            
</app-panel>

</template>

<script>

import Vue from 'vue'

export default {

    props: ['type', 'id'],

    data: function() {
    
        return {
            is: {
                loading: true
            },
            references: {},
            item: {}
        }
    
    },

    components: {
        'admin': () => import('./Admin'),
        'user': () => import('./User'),
        'membership-subscription': () => import('./membership/Subscription'),
        'organisation': () => import('./Organisation'),
        'convention-badge': () => import('./convention/Badge'),
        'convention-badge-type': () => import('./convention/badge/Type'),
        'convention-volunteers-assignment': () => import('./convention/volunteers/Assignment'),
        'convention-volunteers-whitelist': () => import('./convention/volunteers/Whitelist'),
        'convention-volunteers-signup': () => import('./convention/volunteers/Signup'),
        'convention-volunteers-role': () => import('./convention/volunteers/Role'),
        'convention-volunteers-slot': () => import('./convention/volunteers/Slot'),
        'convention-registration-application': () => import('./convention/registration/Application'),
        'convention-registration-sale': () => import('./convention/registration/Sale'),
        'organisation-library-game': () => import('./organisation/library/Game')
    },

    computed: {

        hasRoute: function() {
        
            return !this.$_.contains(['user', 'admin'], this.type)

        },
    
        componentName: function() {
        
            return this.type.replace(/\//g, '-')
        
        }
    
    },

    created: function() {
    
        this.load()

        this.$pubsub.$on('preview', this.onPreview.bind(this))

    },

    beforeDestroy: function() {
    
        this.$pubsub.$off('preview', this.onPreview.bind(this))

    },

    watch: {
    
        id: function(n) {
        
            if (n) this.load()
        
        }

    },

    methods: {

        onPreview: function(value) {
        
            if (value !== this.id) this.$emit('close')

        },

        load: function() {

            this.$pubsub.$emit('preview', this.id)

            this.is.loading = true
        
            this.$api.get(['preview', this.id]).then(function(json) {
            
                Vue.set(this, 'item', json.preview)

                this.$_.each(json, function(value, key) {

                    if (key !== 'preview') Vue.set(this.references, key, value)

				}.bind(this))

                this.is.loading = false
            
            }.bind(this), function() {
            
                this.$notify({
                    message: 'Could not load preview, please try again.',
                    type: 'error'
                })

                this.$emit('close')

            }.bind(this))
        
        },
    
        onManageClick: function(e) {

            e.stopPropagation()
        
            this.$emit('manage', this.item)
            this.$emit('close')

        }
    
    }

}

</script>

<style scoped>

.preview {
    display: flex;
    flex-direction: column;
    cursor: initial;
}

</style>
